import React, { useState, useEffect } from "react";

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import SubsiteService from "../../services/subsite.service";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import FakeNavBar from "../FakeNavBar";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useDispatch } from "react-redux";
import { reloadSubsite, getSubsite, reloadUser } from '../../reducers/auth';
import { useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";

const AdminContent = () => {
  const [value, setValue] = useState('');
  const [menuBgColor, setMenuBgColor] = useState('#000000');
  const [menuTextColor, setMenuTextColor] = useState('#000000');
  const [menuTextHoverColor, setMenuTextHoverColor] = useState('#000000');
  const [topNavBgColor, setTopNavBgColor] = useState('#000000');
  const [lightTheme, setLightTheme] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const currentSubsite = useSelector(getSubsite);

  useEffect(() => {
    async function fetchData() {
      var content = await SubsiteService.getHomepageContent();
      console.log("CONTENT", content);
      setValue(content.homepage);
      setMenuBgColor(content.menuBgColor);
      setMenuTextColor(content.menuTextColor);
      setMenuTextHoverColor(content.menuTextHoverColor);
      setTopNavBgColor(content.topNavBgColor);
      setLightTheme(content.lightTheme);
    }
    fetchData();
  }, []);

  const handleUpdate = async () => {
    setLoading(true);
    var values = {
      homepage: value,
      menuBgColor: menuBgColor,
      menuTextColor: menuTextColor,
      menuTextHoverColor: menuTextHoverColor,
      topNavBgColor: topNavBgColor,
      lightTheme: lightTheme
    };

    var content = await SubsiteService.setHomepageContent(values);
    dispatch(reloadSubsite());
    dispatch(reloadUser());
    setLoading(false);
  }

  const updateTopNavBgColor = (e) => {
    console.log("UPDATE MENU BG COLOR", e.target.value);
    setTopNavBgColor(e.target.value);
    if (isColorLight(e.target.value)) {
      setLightTheme(true);
    } else {
      setLightTheme(false);
    }
  }

  const isColorLight = (color) => {
    // Expand shorthand hex color to full form
    if (color.length === 4) {
      color = '#' + color[1] + color[1] + color[2] + color[2] + color[3] + color[3];
    }

    const hex = color.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16) / 255;
    const g = parseInt(hex.substring(2, 4), 16) / 255;
    const b = parseInt(hex.substring(4, 6), 16) / 255;

    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

    // Adjust the threshold as needed
    return luminance > 0.5;
  }

  return (

    <div className="container">
      <h4>Homepage Content:</h4>
      <ReactQuill theme="snow" value={value} onChange={setValue} />
      <Container>
        <Row style={{marginTop: 10, marginBottom: 10}}>
          <Col>
          <Form.Label htmlFor="topNavBgColor">Top Nav BG Color</Form.Label>
        <Form.Control
          type="color"
          id="topNavBgColor"
          defaultValue={topNavBgColor}
          title="Choose your color"
          onChange={updateTopNavBgColor}
        />
          </Col>
          <Col>
          <Form.Label htmlFor="menuBgColor">Menu BG Color</Form.Label>
        <Form.Control
          type="color"
          id="menuBgColor"
          defaultValue={menuBgColor}
          title="Choose your color"
          onChange={(e) => setMenuBgColor(e.target.value)}
        />
          </Col>
          <Col>
          <Form.Label htmlFor="menuTextColor">Menu Text Color</Form.Label>
        <Form.Control
          type="color"
          id="menuTextColor"
          defaultValue={menuTextColor}
          title="Choose your color"
          onChange={(e) => setMenuTextColor(e.target.value)}
        />
          </Col>
          <Col>
          <Form.Label htmlFor="menuTextHoverColor">Menu Text Hover Color</Form.Label>
        <Form.Control
          type="color"
          id="menuTextHoverColor"
          defaultValue={menuTextHoverColor}
          title="Choose your color"
          onChange={(e) => setMenuTextHoverColor(e.target.value)}

        />
          </Col>
        </Row>
      </Container>
      <FakeNavBar topNavBgColor={topNavBgColor} menuBgColor={menuBgColor} menuTextColor={menuTextColor} menuTextHoverColor={menuTextHoverColor} lightTheme={lightTheme} />
      <div style={{ marginTop: 10, marginBottom: 10 }}>
        <Button variant="primary" onClick={handleUpdate} disabled={loading}>
          {loading && (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          )}
          Update Homepage
        </Button>
      </div>

    </div>
  );
};
export default AdminContent;